import styled from "styled-components";

const Radio = styled.section`
  background: #f9fcff;
  border: 1px solid #436ab2;
  padding: 2rem 1.2rem;
  border-radius: 10px;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  user-select: none;
  cursor: pointer;
  transition: 0.2s all ease-in-out;
  &:hover {
    background-color: #e6f0ff;
  }
`;

const RadioWrapper = styled.section`
  margin-bottom: 1.2rem;
`;

const Image = styled.img`
  width: 2rem;
  margin-right: 2rem;
  user-select: none;
  pointer-events: none;
`;

const RadioListWrapper = styled.section`
  margin-top: 6rem;
  max-width: 800px;
`;

export { Radio, RadioWrapper, Image, RadioListWrapper };
